﻿import { currency_info } from "./currency_info";

export class currency {
    iso_country_code: string = "";
    country: string = "";
    dialing_code: string = "";
    currency_info: currency_info = new currency_info();
}